/* global __CLIENT__ */
import React, {
    useState, useEffect, useMemo,
} from 'react';
import PropTypes from 'prop-types';
import animateScrollTo from 'animated-scroll-to';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRss } from '@fortawesome/free-solid-svg-icons';
import exact from 'prop-types-exact';
import Button from '../../../common/button/Button';
import Spinner from '../../../common/Spinner/Spinner';
import { showError } from '../../../common/A1Alert/A1Alert';

// @TODO move the following into a helper or config and use it in other places as well (like the sharing component)
let host;

if (__CLIENT__) {
    host = `${window.location.protocol}//${window.location.hostname === 'localhost' ? 'localhost:3000' : window.location.hostname}`;
} else {
    host = process.env.BASE_APP_URL || 'https://www.antena1.com.br';
}

const Feeds = (props) => {
    const [feedType, setFeedType] = useState('atom');
    const [copiedId, setCopiedId] = useState(null);

    useEffect(() => {
        animateScrollTo(0, { speed: 700 });

        props.getNewsCategoryIfNeeded();

        return undefined; // so the linter won't complain
        // the following line is necessary because the linter complains about the empty brakets
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // computed during render (not in an effect) so the list is part of the server-rendered HTML
    const categories = useMemo(() => (
        props.newsCategories.length > 0
            ? [{ id: -1, name: 'Todas', slug: 'all' }, ...props.newsCategories]
            : false
    ), [props.newsCategories]);

    const copyLink = (id, href) => {
        // navigator.clipboard only exists in secure contexts (https/localhost)
        if (!navigator.clipboard) {
            showError('Não foi possível copiar o link. Selecione e copie o endereço manualmente.');

            return;
        }

        navigator.clipboard.writeText(href)
            .then(() => {
                setCopiedId(id);

                setTimeout(() => setCopiedId(null), 2000);
            })
            .catch(() => showError('Não foi possível copiar o link. Selecione e copie o endereço manualmente.'));
    };

    const mountFeedLink = (category) => {
        const href = `${host}/feed/${feedType}/${category.slug}`;
        const title = `Link para o feed das noticias da categoria ${category.name} em formato ${feedType}`;

        return (
            <li key={category.id} className="feedsLi">
                {/*
                <Button className="feedLink">
                    {' '}
                    {category.name}
                    {` (${feedType})`}
                </Button>
                */}

                <div className="feedsLiIconAndTextContainer">
                    <FontAwesomeIcon icon={faRss} className="feedIcon" width="16" />
                    <div>
                        <p>
                            {`${category.name} (${feedType})`}
                        </p>
                        <code className="feedUrl">
                            {href}
                        </code>
                    </div>
                </div>

                <div className="feedActions">
                    <button
                        type="button"
                        className="feedCopyButton"
                        onClick={() => copyLink(category.id, href)}
                        title={`Copiar o link do feed ${category.name} em formato ${feedType}`}
                    >
                        {copiedId === category.id ? 'Copiado!' : 'Copiar link'}
                    </button>
                    <a href={href} title={title}>
                        Acesse
                    </a>
                </div>
            </li>
        );
    };

    return (
        <section className="feedsSection">
            <header>
                <h1>Feeds da Antena 1</h1>
                <p className="pageSubtitle">Conheça as opções de feed que a Antena 1 oferece abaixo</p>
            </header>
            <div className="feedsContent">
                <div className="feedsDescription">
                    <div className="feedsDescriptionContent">
                        <p>
                            Assine gratuitamente os feeds da Antena 1 e receba alertas de atualização assim que novas notícias forem publicadas.
                            Escolha na lista abaixo as categorias que mais te interessam e adicione o feed ao seu navegador ou agregador preferido.
                        </p>
                        <p className="tw-mb-0">
                            Para assinar, toque em &quot;Copiar link&quot; e cole o endereço no seu agregador de feeds.
                            Se preferir abrir o feed direto no navegador, verá o código do feed. É normal, basta voltar à página anterior.
                        </p>
                    </div>
                </div>
                <div className="feedTypeButtons">
                    <Button onClick={() => setFeedType('atom')} title="Feeds em formato atom" className={`feedTypeButton ${feedType === 'atom' ? 'active' : ''}`}>
                        Atom (1.0)
                    </Button>
                    <Button onClick={() => setFeedType('rss')} title="Feeds em formato rss" className={`feedTypeButton ${feedType === 'rss' ? 'active' : ''}`}>
                        RSS (2.0)
                    </Button>
                    <Button onClick={() => setFeedType('json')} title="Feeds em formato json" className={`feedTypeButton ${feedType === 'json' ? 'active' : ''}`}>
                        JSON
                    </Button>
                </div>
                <div className="feedsList">
                    {!categories ?
                        <Spinner />
                        :
                        <ul className="feedsUl">
                            {categories.map((category) => mountFeedLink(category))}
                        </ul>}
                </div>
            </div>
        </section>
    );
};

Feeds.propTypes = exact({
    newsCategories: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            slug: PropTypes.string,
        }),
    ).isRequired,
    getNewsCategoryIfNeeded: PropTypes.func.isRequired,
});

export default Feeds;
